	export enum AppriseApiCallTypeEnum {
		Invoice = 1,
		Product = 2,
		Customer = 3,
		Payment = 4,
		PO = 5,
		Refund = 6,
		Return = 7,
		SaleRep = 8,
		InsurancePlan = 9,
		InvoiceBatch = 10,
		NetworkProvider = 11
	}
